import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { ApiTokenExpiresInEnum, StatusStateEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert } from "~/components-shared";
import apiTokenSelectors from "~/store/apiTokens/selectors";
import apiTokensActionCreators from "~/store/apiTokens/actions";
import ApiTokenForm from "~/forms/ApiTokenForm";
import apiTokenSchema from "~/forms/ApiTokenForm/apiTokenSchema";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const ApiTokenCreateModal = () => {
  const {
    t
  } = useTranslation();
  const action = useSelector(apiTokenSelectors.getAction);
  const status = useSelector(apiTokenSelectors.getCreateStatus);
  const error = useSelector(apiTokenSelectors.getCreateError);
  const dispatch = useDispatch();
  const defaultValues = {
    name: "",
    scopes: [],
    expiresIn: ApiTokenExpiresInEnum.MONTH
  };
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch
  } = useForm({
    resolver: yupResolver(apiTokenSchema),
    defaultValues
  });
  useEffect(() => {
    if (!action) {
      reset(defaultValues);
    }
  }, [action]);
  const onSubmit = handleSubmit(data => {
    dispatch(apiTokensActionCreators.createStarted(data, _ref => {
      let {
        data: newToken
      } = _ref;
      if (newToken) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("ApiTokenCreateModal.tokenCreated", {
            name: newToken.name
          }),
          timeout: 10000
        }));
        reset(defaultValues);
      }
    }));
  });
  const onCancel = () => {
    dispatch(apiTokensActionCreators.actionChanged(null, null));
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("ApiTokenCreateModal.createToken"),
    onClose: onCancel,
    maxWidth: "560px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(ApiTokenForm, {
    control: control,
    setValue: setValue,
    watch: watch
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("ApiTokenCreateModal.saveToken")))));
};
export default ApiTokenCreateModal;